import { EditFilter } from "@/components/campaign/configuration/EditFilter";
import { getFilterGroupById } from "@/data/filters/config";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_dashboard/campaigns/$id/(edit)/define/advanced/$quality/$category/$filter",
)({
  component: RouteComponent,
  loaderDeps: () => [],
  loader: ({ params, context }) => {
    const filterGroup = getFilterGroupById(params.filter);

    const title = [context.configuration.name, filterGroup?.group.title]
      .filter(Boolean)
      .join(" - ");

    return {
      filterGroup,
      crumb: title,
      meta: {
        title: title,
      },
    };
  },
});

function RouteComponent() {
  const { useAdvancedConfiguration } = Route.useRouteContext();
  const { filter } = Route.useParams();
  const navigate = Route.useNavigate();

  const [configuration, setConfiguration] = useAdvancedConfiguration();

  return (
    <div>
      <EditFilter
        configuration={configuration}
        setConfiguration={setConfiguration}
        isNewCampaign
        onUpdated={() => {
          navigate({ to: "/campaigns/$id/define/advanced" });
        }}
        backLinkOptions={{ to: "/campaigns/$id/define/advanced" }}
        filterGroupId={filter}
        hideCancelButton={false}
        hasBorder={false}
      />
    </div>
  );
}
